module.exports = __webpack_public_path__ + "img/acrylic.73ebf019.png";